<script setup>
import TasksTab from "@/components/tasks/TasksTab.vue";
import { onMounted, ref } from "vue";
import "vue3-toastify/dist/index.css";

const hasViewTasksPermission = ref(false)

onMounted(() => {
  const userData = JSON.parse(localStorage.getItem('userData'));
  const userPermissionsByRoles = userData.permissions_by_roles;
  
  // Check if user has permission to view tasks (own or all)
  const viewAllTasksPermission = Object.values(userPermissionsByRoles)
    .some((permissions) => permissions.includes("View All Tasks"));
  
  const viewOwnTasksPermission = Object.values(userPermissionsByRoles)
    .some((permissions) => permissions.includes("View Own Tasks"));
  
  if (viewAllTasksPermission || viewOwnTasksPermission) {
    hasViewTasksPermission.value = true 
  }
});

definePage({ meta: { requiresAuth: true } });
</script>

<template>
  <div>
    <VCard title="" class="">
      <VCardText class="p-0" style="padding: 0 !important">
        <div v-if="hasViewTasksPermission" >
          <TasksTab />
        </div>
      </VCardText>
    </VCard>
  </div>
</template> 